const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Whether the weekly-insights popup is eligible to show, by date alone:
 *  - only on Saturday or Sunday (a near-complete week of data to reflect on), and
 *  - only for accounts at least 7 days old (new users have no week of history yet).
 * Storage-based "already viewed this week" checks live in the store.
 */
export function isWeeklyInsightPopupDay(now: Date, accountCreatedAt: string): boolean {
  const day = now.getDay(); // 0=Sun … 6=Sat
  const isWeekend = day === 0 || day === 6;
  if (!isWeekend) return false;

  const created = new Date(accountCreatedAt);
  return now.getTime() - created.getTime() >= SEVEN_DAYS_MS;
}
